import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import TermsPolicyContent from '../components/TermsPolicyContent';

export default function TermsPolicyPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-[calc(100dvh-8rem)] bg-[#141414] text-white px-5 py-4 md:py-6">
      <div className="mx-auto w-full max-w-sm">
        <button
          type="button"
          onClick={() => navigate('/profile')}
          className="mb-5 inline-flex items-center gap-2 text-xs font-black uppercase tracking-wide text-white/60 hover:text-white transition"
        >
          <ArrowLeft size={14} /> Back to Profile
        </button>

        <h1 className="text-[22px] font-semibold tracking-tight text-white mb-4">
          Terms & Policy
        </h1>

        <TermsPolicyContent />
      </div>
    </div>
  );
}
